<template>
    <span>
        <GekkoButton 
            v-if="!initialGroup" 
            @click="openModal"
            premium-modal 
            premium-code="'web_products_creategroup'"
            :text="$gettext('Create group')" 
            icon="fa-solid fa-plus"
            variant="outline-primary"
        />
        <GekkoButton 
            v-else
            @click="openModal"
            premium-modal 
            premium-code="'web_products_editgroup'"
            icon="fa-solid fa-pen-to-square"
            variant="link"
        />
        <b-modal v-model="showModal" size="lg">
            <template #modal-header>
                <h3 v-if="!initialGroup" v-translate>Create product group</h3>
                <h3 v-if="initialGroup" v-translate>Edit product group</h3>
                <GekkoButton 
                    @click="closeModal()"
                    icon="fa-solid fa-xmark"
                    variant="link"
                    class="close text-unassigned"
                />
            </template>
            <template #default>
                <b-alert :show="showDismissibleCountdown" variant="danger" dismissible @dismissed="showDismissibleCountdown=0" v-translate>
                  A group with this name already exists.
                </b-alert>
                <b-form>
                    <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" label-class="gk-label-margin" :label="$gettext('Group name*')" label-for="input-1">
                        <b-form-input id="input-1" class="col-sm-6" v-model="group.name" required></b-form-input>
                    </b-form-group>
                </b-form>
            </template>
            <template #modal-footer>
                <button type="button" class="btn btn-default" @click="closeModal()" v-translate>Cancel</button>
                <button type="button" class="btn btn-primary" @click="addGroup()" v-translate>Save</button>
            </template>
        </b-modal>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';

import UserService from "@/store/services/user.service.js";
import ProductGroupService from "@/store/services/productgroup.service.js";
import GekkoButton from "@/components/GekkoButton";

export default {
    name: "CreateProductGroup",
    components: { GekkoButton },
    props: {
        initialGroup: Object,
        createdCallback: {type: Function}
    },
    data() {
        return {
            showDismissibleCountdown:0,
            group: {
                company_profile: null,
                name: "",
            },
            showModal: false,
            isPremium: false,
        }
    },
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId'
        }),
    },
    created(){
        this.group.company_profile = this.getCompanyId
        if(this.$props.initialGroup){
            this.group.name = this.$props.initialGroup.name;
        }
    },
    methods: {
        openModal(){
            this.group.name = ''
            if(this.$props.initialGroup){
                this.group.name = this.$props.initialGroup.name;
            }
            var vm = this;
            UserService.retrieveCurrent({extended: 'True'}).then(function(response){
                vm.isPremium = response.data.is_premium;
                if(vm.isPremium){
                    vm.showModal = true;
                }else{
                    vm.$store.commit('togglePremiumModal');
                }
            });
        },
        closeModal(){

            this.showModal = false;
        },
        addGroup(){
            var vm = this;
            if(this.initialGroup) {
                ProductGroupService.partial_update(this.initialGroup.id, {name: this.group.name}).then(function () {
                    vm.createdCallback();
                    vm.closeModal();
                }).catch(function (response) {
                    if (response.response.status == 400) {
                        vm.showDismissibleCountdown = 2;
                    }
                })
            }else{
                ProductGroupService.create(this.group).then(function () {
                    vm.createdCallback();
                    vm.closeModal();
                }).catch(function (response) {
                    if (response.response.status == 400) {
                        vm.showDismissibleCountdown = 2;
                    }
                })
            }
        }
    }
};
</script>
<style scoped lang="scss">
.clickable-text{
    cursor: pointer;
    color: $colorBlue;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.clickable-text:hover{
    color: $colorBlue800;
}
</style>
